export interface SubscriptionState {
  isLoading: boolean;
  list: any[];
  error: string | null;
}

export interface UserState {
  openLogout: boolean;
  userSession: Record<string, any>;
  addAddress: boolean;
  savingNewAddress: boolean;
  verifyEmailResponse: Record<string, any>;
  subscription: SubscriptionState;
  updateEmailResponse: Record<string, any>;
  updatePhoneResponse: Record<string, any>;
  validateOTPResponse: Record<string, any>;
  resendOTPResponse: Record<string, any>;
  loading: boolean;
  loginError: string | null;
  isAuthenticated: boolean;

  // Login Flow State
  otpChallengeId: string | null;
  otpExpiresInSeconds: number | null; 
  canResendAt: string | null;
  resendCount: number;
  isOtpLoading: boolean;
  isOtpRequired: boolean;
  loginStep: 'credentials' | 'otp';

  // register state
  registerLoading: boolean;
  registerError: string | null;
  registerSuccessMessage: string | null;
  registerSuccess: boolean;
}

export enum UserActionTypes {
  LOGIN_REQUEST = "user/loginRequest",
  LOGIN_INITIATE_SUCCESS = "user/loginInitiateSuccess", // New: For OTP step
  LOGIN_SUCCESS = "user/loginSuccess",
  LOGIN_FAILURE = "user/loginFailure",

  VERIFY_OTP_REQUEST = "user/verifyOtpRequest",
  VERIFY_OTP_FAILURE = "user/verifyOtpFailure",

  LOGOUT = "user/logout",

  GET_USER_PROFILE_REQUEST = "user/getUserProfileRequest",
  GET_USER_PROFILE_SUCCESS = "user/getUserProfileSuccess",
  GET_USER_PROFILE_FAILURE = "user/getUserProfileFailure",

  SEND_OTP_REQUEST = "user/sendOtpRequest",
  SEND_OTP_SUCCESS = "user/sendOtpSuccess",
  SEND_OTP_FAILURE = "user/sendOtpFailure",

  FETCH_SESSION_REQUEST = "user/fetchSessionRequest",
  FETCH_SESSION_SUCCESS = "user/fetchSessionSuccess",
  FETCH_SESSION_FAILURE = "user/fetchSessionFailure",

  REGISTER_REQUEST = "user/REGISTER_REQUEST",
  REGISTER_SUCCESS = "user/REGISTER_SUCCESS",
  REGISTER_FAILURE = "user/REGISTER_FAILURE",
}
